import React, {Fragment} from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

export default function Uploader(props){
  return(
      <div style={{position:'relative'}}>
      <FieldArray name={(props.name==undefined)?'upload_documents':props.name}>
      {({ fields }) =>
        <Fragment>
        <Typography color='primary' style={{marginTop:(props.margin_top==undefined)?'30px':props.margin_top, marginBottom:'10px'}}><span style={{marginLeft:'10px'}}>{props.title}</span><AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push('', undefined)}}/></Typography>
        <Grid container>
        {fields.map((name, index) => {

            return(
              <Field name={name}>{(f)=>{return(
                <Grid item md={4} sm={6} xs={12} >
                    <div style={{marginTop:'0px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <span><label htmlFor={name}><input style={{ display: 'none' }} accept="application/pdf" onChange={(e)=>{if(Math.round(e.target.files[0].size/1024)>=5120){alert('The file you uploaded is too big. File must be smaller than 5MB');}else{f.input.onChange(e.target.files[0]);}}} id={name} name={name} type="file"/><Button disabled={(f.input.value!=undefined && f.input.value.name!=undefined)} color={(f.input.value!=undefined && f.input.value.ignore==true)?'secondary':"primary"} variant={(f.input.value==undefined || f.input.value=='')?'outlined':'contained'} component="span">{(f.input.value!=undefined && f.input.value.name!=undefined)?(props.submitted_text==true)?"Uploaded":"Document uploaded":(props.button_text==undefined)?"Upload document":props.button_text}</Button></label></span>
                    <span><Field name='delete_uploads'>{(df)=><DeleteIcon color='secondary' style={{cursor:'pointer', marginLeft:'20px'}} onClick={()=>{if(fields.value[index].id!=undefined){let arr=df.input.value; if(arr=='' || arr==undefined){arr=[];} arr=JSON.parse(JSON.stringify(arr)); arr.push(fields.value[index].id); df.input.onChange(arr);} fields.remove(index);}}/>}</Field></span>
                    </div>
                    <div style={{height:'40px', overflowX:'scroll', width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography variant='caption' style={{cursor:'pointer'}} onClick={()=>{if(f.input.value!=undefined && f.input.value.id!=undefined){window.location.href='/api/safeDownload/'+f.input.value.id;}}}>{(f.input.value==undefined)?null:f.input.value.name}</Typography></div>
              </Grid>
          )}}</Field>)
          })}
          </Grid>
          <div style={{marginBottom:(props.margin_bottom==undefined)?'20px':props.margin_bottom}}/>
          </Fragment>
        }
          </FieldArray>
          </div>
    )
}
